import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form/immutable';

import { showDialog, hideDialog, showWarning } from '../../actions/dialogs';
import { renderJobProfileDrilldown } from '../../utils/reduxforms';

import { toArray } from '../../utils/helper';
import { required } from '../../utils/formvalidation';
import validate from './validate';

class Page2 extends React.Component {
  static propTypes = {
    roles: PropTypes.array.isRequired,
    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    showWarning: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  };

  state = {};

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <Field
          name="profile"
          component={renderJobProfileDrilldown}
          validation={[required]}
        />
      </form>
    );
  }
}

const form = reduxForm({
  form: 'wizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(Page2);

function mapStateToProps(state) {
  return {
    roles: toArray(state.get('roles').get('roles').toJS()),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    showWarning,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/CreateJobDialog/Page2.js